import React, { Fragment } from "react";
import { useSelector, useDispatch, StateProps } from "react-redux";
import { setDialog } from "../../actions/modalActions";
import {
  AddBrokerModal,
  ModelSubConfirmModal,
  AddBrokerSuccessModal,
  DeleteBrokerModal,
  DeleteBrokerSuccessModal,
  OTPConfirmModal,
  SnakbarModal,
} from "./modals";

export type Ref = HTMLDivElement;

type Props = {
  children: React.ReactNode;
  rest?: any;
};

const ModalProvider = React.forwardRef<Ref, Props>((Props, ref) => {
  const modalState = useSelector((state: StateProps) => state.modal);
  const dispatch = useDispatch();

  const handleClose = () => {
    Object.keys(modalState.modalStatus).forEach((modalName) => {
      dispatch(setDialog(modalName, false));
    });
  };

  //use to go back to X prev dialog , when backCount = x mean go back to x prev dialog
  //so 1 mean prev closed dialog
  const handleBack = (backCount = 1) => {
    let prevPopup =
      modalState.prevModal[modalState.prevModal.length - backCount];
    dispatch(setDialog(prevPopup, true));
  };

  return (
    <Fragment>
      {Props.children}
      <AddBrokerModal
        open={modalState.modalStatus.addBrokerModal}
        handleClose={handleClose}
        handleBack={handleBack}
      />
      <ModelSubConfirmModal
        open={modalState.modalStatus.modelSubConfirmModal}
        handleClose={handleClose}
        handleBack={handleBack}
        props={modalState.props}
      />
      <AddBrokerSuccessModal
        open={modalState.modalStatus.addBrokerSuccessModal}
        handleClose={handleClose}
        handleBack={handleBack}
        props={modalState.props}
      />
      <DeleteBrokerModal
        open={modalState.modalStatus.deleteBrokerModal}
        handleClose={handleClose}
        handleBack={handleBack}
        props={modalState.props}
      />
      <DeleteBrokerSuccessModal
        open={modalState.modalStatus.deleteBrokerSuccessModal}
        handleClose={handleClose}
        handleBack={handleBack}
        props={modalState.props}
      />
      <OTPConfirmModal
        open={modalState.modalStatus.otpConfirmModal}
        handleClose={handleClose}
        handleBack={handleBack}
        props={modalState.props}
      />
      <SnakbarModal
        open={modalState.modalStatus.snackbarModal}
        handleClose={handleClose}
        handleBack={handleBack}
        props={modalState.props}
      />
    </Fragment>
  );
});

export default ModalProvider;
